/**
 * Global Error Boundary
 * Created: 2024-08-10
 * Updated: 2024-11-12 - Fixed Next.js 15 compatibility by removing html and body tags
 *
 * This component catches runtime errors in the application
 * and displays a friendly error message.
 */

'use client'

import {useEffect} from 'react'

export default function GlobalError({error, reset}: {error: Error & {digest?: string}; reset: () => void}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Global error caught:', error)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong!</h1>
        <p className="mb-4 text-gray-700">We're sorry, but an unexpected error has occurred.</p>
        <button onClick={reset} className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
          Try again
        </button>
      </div>
    </div>
  )
}
